var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-navigation-drawer',{staticClass:"navigation-drawer",attrs:{"clipped":_vm.$vuetify.breakpoint.lgAndUp,"width":"280","app":"","touchless":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('nested-menu',{attrs:{"menu-items":_vm.menu}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }